<template>
  <el-menu
    class="menu-nav"
    router
    :default-active="$route.path"
    background-color="#20222A"
    text-color="rgba(255,255,255,.8)"
    active-text-color="#ffd04b"
    :collapse="isCollapse"
  >
    <el-menu-item v-for="i in roles" :key="i.url" :index="i.url">
      <i :class="i.icon || ''"></i>
      <span slot="title">{{ i.name }}</span>
    </el-menu-item>
  </el-menu>
</template>

<script>
export default {
  props: ['isCollapse'],
  data() {
    return {
      // menus: [
      //   { name: '服务记录', url: '/service', icon: 'el-icon-menu' },
      //   { name: '账号管理', url: '/account', icon: 'el-icon-news' },
      //   { name: '订单管理', url: '/orders', icon: 'el-icon-s-order' },
      //   { name: '财务管理', url: '/financial', icon: 'el-icon-s-marketing' },
      //   { name: '客户管理', url: '/connection', icon: 'el-icon-s-custom' },
      //   { name: '医院陪护订单', url: '/orders_', icon: 'el-icon-s-cooperation' },
      //   { name: '护工管理', url: '/nurse-management', icon: 'el-icon-s-check' },
      //   { name: '优惠券管理', url: '/discount-management', icon: 'el-icon-s-ticket' },
      //   { name: '统计管理', url: '/statistics', icon: 'el-icon-s-data' },
      //   { name: '居安托养订单管理', url: '/orders_foster', icon: 'el-icon-printer' },
      //   { name: '居安托养服务记录', url: '/orders_foster_records', icon: 'el-icon-tickets' }
      // ]
    }
  },
  computed: {
    roles() {
      return this.$store.state.rules
    }
  },
  created() {

  }
}
</script>

<style lang="scss" scoped>
  .el-menu {
    border: none;
  }

  .menu-nav:not(.el-menu--collapse) {
    width: 200px;
    min-height: 400px;
  }
</style>
